import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';

const ProvidersPatients = [rest.get(`${API_ROOT}providers-patients`, (req, res, ctx) => res(ctx.json([92, 218])))];
export default ProvidersPatients;
